import { Component, NgModule, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavigationService } from '../../services/navigation.service';
import { BaseComponent } from '../../models/base/base.component';
import { DetailService } from '../../services/detail.service';
import { QuotesModule } from '../quotes/quotes.module';
import { OrdersModule } from '../orders/orders.module';
import { InvoicesModule } from '../invoices/invoices.module';
import { LocationsModule } from '../locations/locations.module';
import { UsersModule } from '../users/users.module';
import { MessageService } from 'primeng/api';
import { Router  } from '@angular/router';


@Component({
  selector: 'detail-modal',
  template: `
<ng-container *ngIf="visible" [ngSwitch]="entityName">
  <ng-container *ngSwitchCase="'quote'">
      <quote-detail [model]="model" [showHeader]="true" [showVehicles]="true" [showModal]="true"></quote-detail>
  </ng-container>
  <ng-container *ngSwitchCase="'order'">
      <order-detail [model]="model" [showHeader]="true" [showVehicles]="true" [showModal]="true"></order-detail>
  </ng-container>
  <ng-container *ngSwitchCase="'invoice'">
      <invoice-detail [model]="model" [showHeader]="true" [showVehicles]="true" [showModal]="true"></invoice-detail>
  </ng-container>
  <ng-container *ngSwitchCase="'location'">
      <location-detail [model]="model" [showModal]="true"></location-detail>
  </ng-container>
  <ng-container *ngSwitchCase="'user'">
      <user-detail [model]="model" [showModal]="true"></user-detail>
  </ng-container>
</ng-container>
`,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [DetailService]
})
export class DetailModalComponent extends BaseComponent implements OnInit, OnDestroy {
  visible = false;
  entityName: string = null;
  entityId: string = null;
  model: any = null;
  subs: any = {};

  constructor(
    private navigationService: NavigationService,
    protected messageService: MessageService,
    private router: Router,
    private detailService: DetailService,
    private ref: ChangeDetectorRef) {
    super();
  }

  ngOnInit() {
    this.subs['showDetail'] = this.navigationService.showDetail$.subscribe(v => {
      this.visible = v;
    });

    this.subs['detail'] = this.navigationService.detail$.subscribe(d => {
      this.entityId = d.entityId;
      this.entityName = d.entityName;
      this.load();
    });
  }

  ngOnDestroy() {
    this.safeUnsub('showDetail');
    this.safeUnsub('detail');
  }

  safeUnsub(key: string) {
    if (this.subs[key] != null && this.subs[key].unsubscribe != null) {
      this.subs[key].unsubscribe();
    }
  }

  load() {
    this.model = null;
    switch (this.entityName) {
      case 'user':
        this.detailService.user(this.entityId)
          .subscribe(r => {
            this.model = r.body.result;
            this.ref.markForCheck();
          });
        break;
      case 'order':
        this.detailService.order(this.entityId)
          .subscribe(r => {
            this.model = r.body.result;
            this.ref.markForCheck();
          });
        break;
      case 'invoice':
        this.detailService.invoice(this.entityId, true)
          .subscribe(r => {
            this.model = r.body.result;
             if (
               !this.router.url.includes("search") &&
               !this.router.url.includes("invoices/account_payable") &&
               !this.router.url.includes("invoices/ach") &&
               !this.router.url.includes("invoices/ach_documents_required") &&
               !this.router.url.includes("invoices/ach_ready_to_pay") &&
               !this.router.url.includes(
                 "invoices/ach_ready_to_pay_over_the_next_week"
               ) &&
               !this.router.url.includes("invoices/ach_pay_today") &&
               !this.router.url.includes("invoices/mail") &&
               !this.router.url.includes("invoices/mail_documents_required") &&
               !this.router.url.includes("invoices/mail_ready_to_pay") &&
               !this.router.url.includes(
                 "invoices/mail_ready_to_pay_over_the_next_week"
               ) &&
               !this.router.url.includes("invoices/mail_pay_today") &&
               !this.router.url.includes("invoices/carrier_payments_on_hold") &&
               !this.router.url.includes("invoices/account_receivable") &&
               !this.router.url.includes("invoices/invoice_needs_to_be_sent") &&
               !this.router.url.includes("invoices/customer_billing") &&
               !this.router.url.includes("invoices/late_customer_payment") &&
               !this.router.url.includes("invoices/carrier_billing") &&
               !this.router.url.includes("invoices/late_carrier_payment") &&
               !this.router.url.includes("invoices/commission_info_required") &&
               !this.router.url.includes("invoices/invoice_totalcost_null") &&
               !this.router.url.includes("invoices/ready_to_audit") &&
               !this.router.url.includes("invoices/invoices_with_issues")
             ) {
               this.router.navigate(["/invoices/active"]);
               this.navigationService.setLeftNav(null, "invoices");
             }
            this.ref.markForCheck();
          }, err => {
            if (err && err.error && err.error.message != null) {
              this.messageService.add(this.toast(true, err.error.message));
            } else if (err && err.status && err.status == 500) {
              this.messageService.add(this.toast(true, 'Internal Server Error'));
            }
            this.visible = false;
            this.ref.markForCheck();
          });
        break;
      case 'location':
        this.detailService.location(this.entityId)
          .subscribe(r => {
            this.model = r.body.result;
            this.ref.markForCheck();
          });
        break;
      case 'quote':
        this.detailService.quote(this.entityId)
          .subscribe(r => {
            this.model = r.body.result;
            this.ref.markForCheck();
          });
        break;
    }
  }

}

@NgModule({
  imports: [
    CommonModule,
    QuotesModule,
    OrdersModule,
    InvoicesModule,
    LocationsModule,
    UsersModule,
  ],
  declarations: [
    DetailModalComponent,

  ],
  exports: [
    DetailModalComponent
  ]
})
export class DetailModalModule { }
